import { get, patch, post } from "@services/apiService.js";

export default {
  managesPage({ data }) {
    return patch(`/v4/design-manager/v1.1/metadata?version=${process.env.VUE_APP_RENDER_VERSION}`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },
  checkUrlDuplicate(data) {
    return post(`/v4/design-manager/v1/page/check-url`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },
  memberGroup(data) {
    return get(`/v4/member-manager/v1/permission/groups`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },
  getPagesUsed(data) {
    return get(`/v4/design-manager/v1/page/pages-used`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },
};
